const HistoricalReportsIconMenu = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        width="32"
        height="32"
        rx="6.64935"
        fill="url(#paint0_linear_2692_11649)"
        fill-opacity="0.1"
      />
      <path
        d="M21.1585 10.3739H19.7517V9.43696C19.7517 8.91853 19.3332 8.5 18.8148 8.5C18.2964 8.5 17.8779 8.91853 17.8779 9.43696V10.3739H14.1275V9.43696C14.1275 8.91853 13.709 8.5 13.1906 8.5C12.6722 8.5 12.2537 8.91853 12.2537 9.43696V10.3739H10.8469C10.0666 10.3739 9.4375 11.0058 9.4375 11.7807V13.1875H22.5625V11.7807C22.5625 11.0031 21.9334 10.3739 21.1558 10.3739H21.1585Z"
        fill="#052351"
      />
      <path
        d="M9.4375 14.125V22.0936C9.4375 22.871 10.0665 23.5 10.8439 23.5H21.1561C21.9335 23.5 22.5625 22.871 22.5625 22.0936V14.125H9.4375ZM16.2511 15.7419C16.6641 15.7743 17.069 15.8931 17.4361 16.0848C17.8033 16.2764 18.1272 16.5437 18.3891 16.8676C18.6509 17.1888 18.8453 17.5613 18.9587 17.9608L16.1701 18.5169C16.135 18.4629 16.1026 18.4035 16.0756 18.3442L15.0282 15.8904C15.4223 15.7581 15.838 15.7068 16.2538 15.7419H16.2511ZM17.1959 21.6482C16.7829 21.8237 16.3347 21.9074 15.8839 21.8912C15.4331 21.875 14.9931 21.7616 14.5936 21.5564C14.194 21.3513 13.8431 21.0624 13.565 20.7061C13.2897 20.3525 13.0926 19.9395 12.9928 19.5022C12.8929 19.0649 12.8902 18.6087 12.9847 18.1687C13.0791 17.7287 13.2681 17.3157 13.5408 16.9567C13.8134 16.5976 14.1589 16.3034 14.5585 16.0929L15.6086 18.5493C15.7301 18.83 15.9217 19.0757 16.1647 19.2619L18.2838 20.8762C17.9814 21.2109 17.6116 21.4755 17.1986 21.6509L17.1959 21.6482ZM18.5942 20.4686L16.6074 18.9542L19.0612 18.4656C19.0747 18.5817 19.0828 18.6978 19.0828 18.8138C19.0828 19.4023 18.9155 19.9746 18.5969 20.4686H18.5942Z"
        fill="#052351"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2692_11649"
          x1="15.7922"
          y1="0"
          x2="15.7922"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0062FF" />
          <stop offset="1" stop-color="#004BC2" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default HistoricalReportsIconMenu
